<template>
  <h1 class="text-3xl">
    <slot />
  </h1>
</template>

<script>
export default {}
</script>
